import axios from "axios";
import { tmsApi } from "../api";

export const getCustomers = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + `v1/entities/customer?serviceCityName=${obj.serviceCityName}&page=${obj.page}&size=${obj.size}`, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const getTripsByCustomer = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + `v1/entities/findtrip/${obj.customerId}`, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const getBookingsByCustomer = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + `v1/entities/bookings/${obj.customerId}?page=${obj.page}&size=${obj.size}`, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const getCustomersCount = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + `v1/entities/customer/count?serviceCity=${obj.serviceCityName}`, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};



export const getCustomerDetails = async (custId) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*"
    },
  };
  try {
    return axios.get(tmsApi + `v1/entities/customer/${custId}`, config).then((resp) => {
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};


export const editCustomer = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  try {
    return axios.put(tmsApi + "v1/entities/customer",body, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const deleteCustomerById = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  try {
    return axios.delete(tmsApi + `v1/entities/customer/${body.custId}`, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};  


export const getCustomerTableFilterData = async (obj, body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/entities/customer/filter?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getCustomerTableSearchData = async (obj, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/entities/customer/search?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};